/**
 Author - Suyash Chandra
 Git - https://bitbucket.org/SuyashChandra/
 **/

import TeamMemberCarousel from "./TeamMemberCarousel";

export default TeamMemberCarousel;
